var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":"Campaigns","header-bg-variant":"primary","header-text-variant":"white"}},[_c('CreatePromotionForm'),_c('PromotionsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }